/**
 * V2 Yoink — data access. Split out of yoink.js on 2026-07-25 (452 lines
 * against the plan's ~400 budget), unchanged.
 */
import * as gateway from '../../core/gateway.js';
import { cached } from '../../core/query.js';

const YOINK_SELECT =
  '*,locations(id,display_name,lat,lng,formatted_address),' +
  'public_profiles(id,username,full_name,avatar_url),' +
  'categories:category_id(id,name,emoji)';

export async function fetchYoink(id) {
  return cached(`yoink:${id}`, async () => {
    const { data, error } = await gateway.rawQuery(gateway.TABLES.YOINKS, {
      select: YOINK_SELECT,
      filters: { id: `eq.${id}` },
      limit: 1,
    });
    if (error) throw error;
    return data?.[0] || null;
  });
}

/**
 * The owner's whole run in this yoink's category, oldest first — enough
 * to say "Stop #31 in Dru's Airports — see all 47" on the
 * yoink page (2026-07-26, landing-pages push step 3). ids + dates only;
 * capped at 1000, and the caller must SAY so ("1000+") rather than
 * pass a capped count off as a total (docs/ASSESSMENT-2026-07.md on
 * silent caps).
 */
export const COLLECTION_CONTEXT_CAP = 1000;

export async function fetchCollectionContext(userId, categoryId) {
  return cached(`yoink-collection:${userId}:${categoryId}`, async () => {
    const { data, error } = await gateway.rawQuery(gateway.TABLES.YOINKS, {
      select: 'id,created_at',
      filters: { user_id: `eq.${userId}`, category_id: `eq.${categoryId}` },
      order: 'created_at.asc,id.asc',
      limit: COLLECTION_CONTEXT_CAP,
    });
    if (error) throw error;
    return data || [];
  });
}
